import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["id", "value"]
const _hoisted_2 = ["for", "onMouseenter", "onMouseleave"]

import {
  HTMLAttributes,
  ComponentPublicInstance,
  onBeforeUnmount,
  onMounted,
  nextTick,
  ref,
  watch,
} from "vue";

type TSegmentedOption = {
  label: string;
  value: string;
};

const groupName = "segmented";

export default /*#__PURE__*/_defineComponent({
  __name: 'FrSegmented',
  props: {
    modelValue: { default: () => {
      return { label: "Все отзывы", value: "false" };
    } },
    options: {},
    defaultOption: {},
    customStyle: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

// Modules
const props = __props;

const emit = __emit;

const segm = ref<HTMLDivElement | null>(null);
const selectedIndex = ref<number>(0);
const labelRefs = ref<HTMLElement[]>([]);
const highlightStyle = ref<Record<string, string>>({
  transform: "translateX(0)",
  width: "0px",
});
const isHoveringSelected = ref<boolean>(false);

function setLabelRef(
  el: Element | ComponentPublicInstance | null,
  index: number
) {
  if (!el) return;

  const element = el instanceof HTMLElement ? el : (el as any as ComponentPublicInstance)?.$el;
  if (element instanceof HTMLElement) {
    labelRefs.value[index] = element;
  }
}

function updateHighlight() {
  const index = selectedIndex.value >= 0 ? selectedIndex.value : 0;
  const labelEl = labelRefs.value[index];

  if (!labelEl) return;

  const left = labelEl.offsetLeft;
  const width = labelEl.offsetWidth;
  highlightStyle.value = {
    transform: `translateX(${left}px)`,
    width: `${width}px`,
  };
}

function onChange() {
  nextTick().then(updateHighlight);

  if (props.options) {
    emit("update:modelValue", props.options[selectedIndex.value]);
  }
}

function onResize() {
  updateHighlight();
}

function onLabelEnter(index: number) {
  isHoveringSelected.value = index === selectedIndex.value;
}

function onLabelLeave(index: number) {
  if (index === selectedIndex.value) {
    isHoveringSelected.value = false;
  }
}

onMounted(async () => {
  await nextTick();
  window.addEventListener("resize", onResize);
  updateHighlight();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});

watch(selectedIndex, () => {
  nextTick().then(updateHighlight);

  onLabelEnter(selectedIndex.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "segmented-control",
    ref_key: "segm",
    ref: segm
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["segmented-highlight", { 'segmented-highlight--hover': isHoveringSelected.value }]),
      style: _normalizeStyle(highlightStyle.value)
    }, null, 6),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (opt, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        _withDirectives(_createElementVNode("input", {
          type: 'radio',
          id: `segmented-${i}`,
          name: groupName,
          value: i,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedIndex).value = $event)),
          onChange: onChange
        }, null, 40, _hoisted_1), [
          [_vModelDynamic, selectedIndex.value]
        ]),
        _createElementVNode("label", {
          for: `segmented-${i}`,
          ref_for: true,
          ref: (el) => setLabelRef(el, i),
          class: _normalizeClass({
          'selected-segmented-label--active': i === selectedIndex.value,
          'selected-segmented-label--hover': isHoveringSelected.value && i === selectedIndex.value,
        }),
          onMouseenter: ($event: any) => (onLabelEnter(i)),
          onMouseleave: ($event: any) => (onLabelLeave(i))
        }, _toDisplayString(opt.label), 43, _hoisted_2)
      ], 64))
    }), 128))
  ], 512))
}
}

})